import { lazy } from 'react';

const Activity = lazy(() => import('./Activity'));

export default Activity;
